import React from 'react'
import { Form, Grid } from 'semantic-ui-react'
import { FormTitle } from '../../../../commonComponents/FormTitle'
import HeaderInfo from './headerInfo1'
const TransportationForm = (props) => {
  const {
    isFormEnabled,
    isImportShipment,
    fieldPattern,
    validateError
  } = props

  return (
    <Form.Group className='float-container'>
      <FormTitle title='Transportation'></FormTitle>
      <Grid className='kn__grid'>
        <HeaderInfo
          isImportShipment={isImportShipment}
          fieldPattern={fieldPattern}
          validateError={validateError}
        />
      </Grid>
    </Form.Group>
  )
}

export default TransportationForm
